import {
  QuestionMarkCircleIcon,
  PhoneIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import SupportContentModal from './SupportContentModal';
import ContentSectionManager from './ContentSectionManager';

const initialSections = [
  { title: 'Page Header', icon: DocumentTextIcon },
  { title: 'FAQs', icon: QuestionMarkCircleIcon },
  { title: 'Contact Support', icon: PhoneIcon },
];

export default function SupportContentContainer() {
  return (
    <ContentSectionManager
      page="support"
      initialSections={initialSections}
      ModalComponent={SupportContentModal}
    />
  );
}
